const LEAD_INTEREST_LABELS: Record<string, string> = {
  hyrox_race_training: 'Training for a HYROX race',
  class_or_session: 'Join a class or session',
  gym_membership: 'Gym membership',
};

const humaniseInterestKey = (value: string): string => {
  const words = value.trim().replace(/_+/g, ' ').replace(/\s+/g, ' ');
  return words ? `${words[0].toUpperCase()}${words.slice(1)}` : '';
};

export const formatLeadInterest = (interest: string): string => {
  const value = interest.trim();
  return LEAD_INTEREST_LABELS[value] ?? humaniseInterestKey(value);
};

export const formatLeadInterests = (interests: readonly string[]): string =>
  interests.map(formatLeadInterest).filter(Boolean).join(', ');

export const formatLeadInterestText = (interestText: string): string => formatLeadInterests(interestText.split(','));
